"use client";

import { cn } from "@/lib/cn";

/**
 * The row of dots under a paged dialog.
 *
 * Real buttons rather than the legacy `<li onClick>`: they are the only way to
 * reach a page other than the next one, so they have to be operable by keyboard.
 *
 * Nothing to show for a single page — there is no "which one" to answer.
 */
export function PageIndicators({
  count,
  activeIndex,
  onSelect,
  label,
}: {
  count: number;
  activeIndex: number;
  onSelect?: (index: number) => void;
  /** Names each dot, e.g. `(i) => \`Page ${i + 1}\``. */
  label: (index: number) => string;
}) {
  if (count <= 1) return null;

  return (
    <ul className="mt-2 flex justify-center">
      {Array.from({ length: count }, (_, index) => (
        <li key={index}>
          <button
            type="button"
            onClick={onSelect ? () => onSelect(index) : undefined}
            disabled={!onSelect}
            aria-current={activeIndex === index ? "page" : undefined}
            aria-label={label(index)}
            className={cn(
              "ml-2.5 h-2.5 w-2.5 rounded-full",
              activeIndex === index ? "bg-[var(--primary)]" : "bg-black",
              onSelect ? "cursor-pointer" : "cursor-default"
            )}
          />
        </li>
      ))}
    </ul>
  );
}
